import * as React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { styled } from "@material-ui/core/styles";
import { CircularProgress, Typography } from "@material-ui/core";

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "white",
  textTransform: "none",
  width: "100%",
  height: "2.5rem",
  padding: theme.spacing(1),
  borderRadius: theme.shape.full,
  transition: "background-color 150ms ease, box-shadow 150ms ease",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark || theme.palette.primary.main,
    boxShadow: theme.boxShadow.elevation2,
  },
  "&.green:disabled": {
    color: theme.palette.green.main,
    backgroundColor: "transparent",
  },
  "&:disabled": {
    backgroundColor: theme.palette.grey.disabled,
    color: theme.palette.text.secondary,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 11,
    lineHeight: 1.2,
  },
  "&.large": {
    padding: `0 ${theme.spacing(5)}px`,
    height: theme.spacing(7),
    minWidth: theme.spacing(24),
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
    },
  },
  "&.small": {
    padding: `0 ${theme.spacing(1)}px`,
    height: "2rem",
    width: "fit-content",
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontStyle: "italic",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: 11,
    lineHeight: 1.2,
  },
}));

export function DisabledButton() {
  return (
    <StyledTypography align="center" variant="caption">
      Purchase option coming soon!
    </StyledTypography>
  );
}

export default function SexyButton({ isLoading, children, ...props }) {
  return (
    <StyledButton
      {...props}
      disabled={Boolean(isLoading) || Boolean(props.disabled)}
    >
      {isLoading ? <CircularProgress size="2rem" /> : children}
    </StyledButton>
  );
}

SexyButton.propTypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};
